var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("mds-combo-box", {
        attrs: {
          label: _vm.translate("frequency.modal.recurrence.label"),
          "data-set": _vm.options,
          "selected-items": [_vm.selectedRecurrence],
        },
        on: {
          input: function ($event) {
            return _vm.$emit("input", { repeatType: $event[0] })
          },
        },
        model: {
          value: _vm.selectedRecurrence,
          callback: function ($$v) {
            _vm.selectedRecurrence = $$v
          },
          expression: "selectedRecurrence",
        },
      }),
      _vm._v(" "),
      _c(
        _vm.recurrenceChildComponent,
        _vm._g(
          _vm._b(
            { tag: "component", staticClass: "frequency-modal__frequencies" },
            "component",
            _vm.recurrenceProps[true],
            false
          ),
          _vm.$listeners
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }